<ul class="step-progressbar">
	<li class="step-progressbar__item" *ngFor="let circle of counter(numOfStepToCircles) ;let i= index"
		[ngClass]="{'step-progressbar__item--complete': i < diffDays && i < numOfStepToCircles && i != activeState,
		'step-progressbar__item--active': i == activeState}">
		<p>In Progress</p>
	</li>
</ul>
